
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Toastr from 'vue-toastr';
import Donut from 'vue-css-donut-chart';
import VueSweetalert2 from 'vue-sweetalert2';
//Translator
import i18n from './plugins/i18n';
//Flag icons
import FlagIcon from 'vue-flag-icon';



import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-toastr/dist/vue-toastr.min.css';
import 'vue-css-donut-chart/dist/vcdonut.css';


Vue.use(VueSweetalert2);
Vue.use(Donut);

//Flag Icons
Vue.use(FlagIcon);

Vue.use(Toastr, { 
	defaultTimeout: 2000,
	// defaultProgressBar: false,
	// defaultProgressBarValue: 0,
	defaultType: "error",
	// defaultPosition: "toast-bottom-left",
	defaultCloseOnHover: false,
	// defaultStyle: { "background-color": "red" }
});

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js